<template>
  <el-main class="login">
    <img class="center-block logo" data-qa="Content-SigninLogo-Image" src="/src/assets/img/admin-logo.png">
    <el-col :span="8" class="reset-pwd-msg" v-if="resetPwdMsg">
      <div class="reset-title" data-qa="Content-SigninResetPwdMsg-Title">
        {{ $t('loginResetResponseTitle') }}
      </div>
      <div class="reset-body" data-qa="Content-SigninResetPwdMsg-Body">
        {{ $t('loginResetResponseMessage') }}
      </div>
    </el-col>
    <el-col :span="8" class="login-form">
      <div class="title">{{ $t('loginFormTitle') }}</div>
      <el-form @submit.native.prevent="validateForm">
        <el-form-item :error="errors.has('email') ? errors.first('email') : ''" :show-message="errors.has('email')" prop="email">
          <el-input @keyup.enter.native="validateForm" :placeholder="$t('loginInputEmailPlaceholder')" clearable data-qa="Content-SigninEmail-Input" name="email" type="text" v-model="email" v-validate="'required|email'" :data-vv-as="$t('loginInputEmailPlaceholder')">
            <i class="fa fa-envelope-open email" slot="prefix"></i>
          </el-input>
        </el-form-item>
        <el-form-item :error="errors.has('password') ? errors.first('password') : ''" :show-message="errors.has('password')" prop="password">
          <el-input @keyup.enter.native="validateForm" :placeholder="$t('loginInputPasswordPlaceholder')" clearable data-qa="Content-SigninPassword-Input" name="password" type="password" v-model="password" v-validate="'required|min:8|max:20'" :data-vv-as="$t('loginInputPasswordPlaceholder')">
            <i class="fa fa-unlock-alt password" slot="prefix"></i>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="validateForm" :disabled="loading || errors.any()" :loading="loading" data-qa="Content-Signin-Button" id="signIn" type="primary">{{ $t('loginButtonSignInText') }}</el-button>
        </el-form-item>
        <a @click="forgetPwd" class="forgot-pwd" data-qa="Content-SigninForgotPassword-Link" type="text">{{ $t('loginLinkForgotPasswordText') }}</a>
      </el-form>
    </el-col>
    <el-col :span="8" v-if="response">
      <el-card>
        <div data-qa="Content-SigninError-Title" slot="header">{{ $t('loginErrorResponseTitle') }}</div>
        <div data-qa="Content-SigninError-Body">{{ response }}</div>
      </el-card>
    </el-col>
  </el-main>
</template>

<script>
  import main from './Login.js'
  export default main
</script>

<style lang="scss" scoped>
  @import './Login.scss'
</style>



// WEBPACK FOOTER //
// Login.vue?68295fae